import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  templateUrl: './too-many-requests.component.html',
  imports: [TranslatePipe]
})
export class TooManyRequestsComponent {}
